import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* collectiveInvoiceExistCheck(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_REQUEST
    })
    
    const res = yield call(Http.get, `contract/${action.payload?.contractId}/collective-invoice-exist?&type=${action.payload?.type}`);
    yield put({
      type: Constants.GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data?.data?.url);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCollectiveInvoiceExistCheck() {
  yield takeEvery(Constants.GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_START, collectiveInvoiceExistCheck);
}
